import { BrowserDeviceType } from '@modules/test-development/components/run-results/machine-config/browser-device-type';
import { MobileDeviceType } from '@modules/test-development/components/run-results/machine-config/mobile-device-type';
import { TestPlanLabType } from '@modules/test-development/enums';
import { TestDevice } from '@testsigmainc/models';

interface DeviceTypeProps {
  testDevice: TestDevice;
  className?: string;
  variant?: 'detail' | 'concise';
}

export const DeviceType: React.FC<DeviceTypeProps> = ({
  testDevice,
  className,
  variant = 'concise',
}) => {
  if (
    (testDevice.isAndroid || testDevice.isIOS) &&
    testDevice.executionLabType != TestPlanLabType.PrivateGrid
  ) {
    return (
      <MobileDeviceType
        deviceName={testDevice.platformDevice?.displayName}
        deviceTitle={testDevice?.title}
        deviceOs={testDevice.platformDevice?.osName}
        isRealDevice={testDevice.isRealDevice}
        className={className}
        variant={variant}
      />
    );
  }
  if (!testDevice.isAndroid && !testDevice.isIOS) {
    return (
      <BrowserDeviceType
        browserName={
          testDevice.platformBrowserVersion?.name || testDevice?.browser
        }
        browserVersion={testDevice.platformBrowserVersion?.displayVersion}
        className={className}
        variant={variant}
        isHeadLess={testDevice.isHeadless}
      />
    );
  }
};
